!((document, Drupal, $) => {
  'use strict';

  function addDataText() {
    var links = $('.inset-form').find('a:not(.dropdown-item)');
    links.each(function() {
      var link = $(this);
      if (link.text()) {
        link.attr('data-text', link.text());
      }
    });
  }
  addDataText();

  Drupal.behaviors.removePaddingBottomWebform = {
    attach: function() {
      let webform = document.querySelector('.paragraph--type--webforms');
      if (webform) {
        let nodeContent = webform.querySelector('.node__content');
        if (nodeContent) {
          nodeContent.style.paddingBottom = 0;
        }
      }
    }
  };
})(document, Drupal, jQuery);
